const getCustomFormElements = (): HTMLCollectionOf<HTMLFormElement> => document.forms;
const getCustomCounterButton = (button: HTMLAnchorElement, input: HTMLInputElement, label: HTMLLabelElement, isPlusButton: boolean) => {
    if (isPlusButton) {
        button.classList.add("custom-counter-add");
        button.setAttribute("data-increment", "true");
    }
    else {
        button.classList.add("custom-counter-minus");
        button.setAttribute("data-increment", "false");
    }    
    button.setAttribute("aria-hidden", "true");    
    button.addEventListener("click", (event: MouseEvent) => {
        if (input.disabled) return;
        if (isPlusButton) {
            if (input.max != undefined && input.max != "") {
                let maxValue: number = parseFloat(input.max);
                if (parseFloat(input.value) < maxValue) {
                    input.value = (parseFloat(input.value) + 1).toString();
                }
            }
            else {
                input.value = (parseFloat(input.value) + 1).toString();
            }
        }
        else {
            if (parseFloat(input.value) > 0) {
                if (input.min != undefined) {
                    let minValue = parseFloat(input.min);
                    if (parseFloat(input.value) > minValue) {
                        input.value = (parseFloat(input.value) - 1).toString();
                    }
                }
                else {
                    input.value = (parseFloat(input.value) - 1).toString();
                }
            }
        }

        if (isPlusButton || (!isPlusButton && parseFloat(input.value) > 0)) {
            let customCounterEvent = new CustomEvent("uh-counter-change", { detail: { increment: true }, bubbles: true });
            let changeEvent: Event = new Event("change", { bubbles: true });
            input.dispatchEvent(customCounterEvent);
            label.dispatchEvent(changeEvent);
        }
    });
};
const addFormIcons = (form: HTMLFormElement) => {
    const labels: HTMLCollectionOf<HTMLLabelElement> = form.getElementsByTagName("label");
    for (let label of labels) {
        // Check if the label is excluded from custom form icons
        const isExcluded: boolean = label.classList.contains("datepicker")
            || label.classList.contains("autosuggest")
            || label.getAttribute("data-custom-opt-out") !== null;

        if (isExcluded) return;
        // Check for an input element within the label
        const input: HTMLInputElement | null = label.querySelector("input");
        if (!input) return;        
        // Check input type and append icon accordingly
        const inputType: string = input.type.toLowerCase();
        if (inputType === "checkbox" || inputType === "radio") {
            let iconElement: HTMLSpanElement = document.createElement("span");
            const hasIconClass: boolean = label.querySelectorAll(".input-icon").length > 0;
            if (!hasIconClass) {
                iconElement.className = "input-icon";
                label.appendChild(iconElement); 
                label.classList.add("custom-ctrl");
            }
        }
        // Counter for number type inputs
        if (inputType === "number"
            && label.classList.contains("custom-counter")
            && !label.querySelectorAll(".custom-counter-add").length) {            
            let fragment: DocumentFragment = document.createDocumentFragment();
            let plusButton: HTMLAnchorElement = document.createElement("a");
            let minusButton: HTMLAnchorElement = document.createElement("a");
            // Get plus button
            getCustomCounterButton(plusButton, input, label, true);
            // Get minus button
            getCustomCounterButton(minusButton, input, label, false);
            // Append buttons to the label
            fragment.appendChild(plusButton);
            fragment.appendChild(minusButton);
            label.classList.add("custom-ctrl");
            label.appendChild(fragment);            
        }
    }
}
export function initializeCustomForms(): void {
    const forms: HTMLCollectionOf<HTMLFormElement> = getCustomFormElements();    
    for (let form of forms) {
        addFormIcons(form);
    }
}

(window as any).LayoutJs = (window as any).LayoutJs || {};
(window as any).LayoutJs.buildCustomForms = initializeCustomForms;

document.addEventListener("DOMContentLoaded", initializeCustomForms);